import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import { Spacer } from '@repo/ui/components/Spacer';

import useNextCharge from '../hooks/useNextCharge';
import useSubscriptionChangeState from '../hooks/useSubscriptionChangeState';
import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

import AddonsSection from './AddonsSection';
import CardSection from './CardSection';
import NextPaymentSection from './NextPaymentSection';
import { PaymentClarification } from './PaymentClarification';
import PlanSection from './PlanSection';
import PromoCodeSection from './PromoCodeSection';
import { Wrapper } from './styles';
import { PlanDetailsTableProps } from './types';

const PaymentInfo: React.FC<PlanDetailsTableProps> = ({
  currentSubscription,
  subscriptionChangePreviewData,
}) => {
  const { preview: changeSubscriptionPreview, isLoading: previewIsLoading } =
    subscriptionChangePreviewData;

  const nextCharge = useNextCharge({
    currentSubscription,
    changeSubscriptionPreview,
  });

  const isChanged = !!useSubscriptionChangeState({ currentSubscription });

  return (
    <Wrapper>
      {isChanged && previewIsLoading && (
        <>
          <Spacer height="48px" />
          <LoadingPlaceholder backgroundStyle="transparent" />
        </>
      )}

      {!previewIsLoading && (
        <>
          <PlanSection
            changeSubscriptionPreview={changeSubscriptionPreview}
            currentSubscription={currentSubscription}
          />

          <AddonsSection />
        </>
      )}

      {!(isChanged && previewIsLoading) &&
        currentSubscription &&
        nextCharge && (
          <FlexColumn gap="4px">
            <PromoCodeSection nextCharge={nextCharge} />
            <PaymentClarification nextCharge={nextCharge} />
            <NextPaymentSection nextCharge={nextCharge} />
          </FlexColumn>
        )}

      {currentSubscription?.card && !previewIsLoading && (
        <CardSection card={currentSubscription.card} />
      )}
    </Wrapper>
  );
};

export default PaymentInfo;
